import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const sentinel = document.getElementById('hero-cta');
    if (!sentinel) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0);
    }, {
      threshold: 0,
      rootMargin: '0px'
    });
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-32" data-mp="gpm4nia3mt6i">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3" data-id="element-33" data-mp="goazpf4x3fdt">
          <div className="mx-auto max-w-md" data-id="element-34" data-mp="14ef1dgyjp526">
            <a href={CHECKOUT_URL} className="shake-cta flex w-full items-center justify-center gap-2 rounded-2xl bg-brand px-4 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_6px_24px_rgba(9,24,48,0.35)] transition-colors duration-150 ease-out hover:bg-brand-dark sm:text-base" data-id="element-35" data-mp="14dn5s64y77bw">
              Accedi ora al Sistema — €19
            </a>
            <p className="mt-1.5 text-center text-[11px] font-semibold text-navy/70" data-id="element-36" data-mp="1repxopl5iv9x">
              Accesso immediato · Garanzia di 7 giorni
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}